import { Constants } from "config/constants";
import { Roles_Permissions_Constants } from "config/roles-permissions";

const checkPLCRegistrar = (officials) => {
  const registrarCandidates = officials.filter((official) =>
    ["Company Secretary"].includes(official.designation)
  );
  const existingRegistrar = registrarCandidates.find(
    (official) => official.isRegistrar
  );
  return {
    registrarCandidates,
    existingRegistrar,
    showSelectRegistrarBtn:
      registrarCandidates.length > 1 && !existingRegistrar,
  };
};

const checkPVTRegistrar = (officials) => {
  const registrarCandidates = officials.filter((official) =>
    ["Company Secretary"].includes(official.designation)
  );

  const existingRegistrar = registrarCandidates.find(
    (official) => official.isRegistrar
  );

  return {
    registrarCandidates,
    existingRegistrar,
    showSelectRegistrarBtn:
      registrarCandidates.length > 1 && !existingRegistrar,
  };
};

export const checkForCompaniesRegistrar = ({
  type = "PLC",
  officials = [],
}) => {
  if (officials.length === 0)
    return { existingRegistrar: false, registrarCandidates: [] };
  switch (type) {
    case "PLC":
      return checkPLCRegistrar(officials);
    case "PVT":
      return checkPVTRegistrar(officials);
    default:
      return { existingRegistrar: false, registrarCandidates: [] };
  }
};
export const getCompanyNameWithSuffix = (company) => {
  if (company && company.registrationName) {
    return company.registrationName;
  }

  if (company && company.companyName1) {
    const companyType = company.type ?? "PLC";
    const nameSuffix = getCompanySuffix(
      company.isCompanyName1Abbreviated,
      companyType
    );

    return `${company.companyName1} ${nameSuffix}`;
  }

  return "N/A"; // Return default value if neither registrationName nor companyName1 is present
};

export const getCompanySuffix = (isAbbreviated, companyType = "PLC") => {
  return isAbbreviated
    ? companyType === "PVT"
      ? "LTD"
      : companyType
    : Constants.COMPANY_NAME_SUFFICE[companyType];
};

export const checkIsVOR = (designation, dashboardRoles, dashboardPermissions) => {
  const { AUTHORIZED_PERSON, SHAREHOLDER, JOINT_SHAREHOLDER } = Constants.APPLICANT_CAPACITIES;
  const { VOR, REVIEWER, APPROVER } = Roles_Permissions_Constants.DASHBOARD_ROLES;

  const isRequiredDesignation = [AUTHORIZED_PERSON, SHAREHOLDER, JOINT_SHAREHOLDER].includes(designation);
  if (!isRequiredDesignation) {
    return false;
  }

  const isVORRole = dashboardRoles.every(role => [VOR, REVIEWER, APPROVER].includes(role.name));
  if (!isVORRole) {
    return false;
  }
  const defaultPermissions = Object.values(Roles_Permissions_Constants.DASHBOARD_PERMISSIONS_AGAINST_DESIGNATIONS[designation] || {})
    .flat();
  const hasDefaultPermissions = dashboardPermissions.every(permission =>
    defaultPermissions.includes(permission.name)
  );
  return hasDefaultPermissions;
};